import { createClient } from "@sanity/client";

export default createClient({
  projectId: "9tlks42z",
  dataset: "production",
  useCdn: true,
  apiVersion: "2021-10-21",
});
